import React, { useEffect } from 'react';

import amplitude from 'amplitude-js';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { INCREASE_LIMITS_CONTINUE_CLICKED, VERIFICATION_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { GA_LEVEL, GT_LEVEL, KYC_PROVIDER, TYPE } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { IDENTITY, INCOME_ADDRESS, SUMSUB } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { AUTH_PROFILE_LIMITS } from 'apps/auth/constants/UrlConstants';
import { useExtra } from 'apps/auth/hooks/selectors';

const CommonIntro = (props) => {
    const { currentLimitLevel, userType, fromTransferFlow, hasSumsub } = useExtra();
    const expectedLevel = currentLimitLevel + 1;
    const amplitudeEventParam = userType === 'ga' ? GA_LEVEL : GT_LEVEL;

    useEffect(() => {
        if (fromTransferFlow) {
            const type = currentLimitLevel === 0 ? IDENTITY : INCOME_ADDRESS;
            amplitude.getInstance().logEvent(VERIFICATION_SCREEN_SHOWN, { [TYPE]: type });
        }
    }, [fromTransferFlow]);

    let navBarProps = {};
    if (props.secondButton) {
        navBarProps = {
            topButtonType: 'link',
            topButtonCaption: props.secondButton,
            topButtonLink: props.secondButtonLink ? props.secondButtonLink : AUTH_PROFILE_LIMITS,
            topButtonOnClick: props.topButtonOnClick,
        };
    }

    const sendEvent = () => {
        const params = { [amplitudeEventParam]: expectedLevel };
        if (!fromTransferFlow) {
            if (hasSumsub) {
                params[KYC_PROVIDER] = SUMSUB;
            }
            amplitude.getInstance().logEvent(INCREASE_LIMITS_CONTINUE_CLICKED, params);
        }
        if (props.primaryButtonOnClick) {
            props.primaryButtonOnClick();
        }
    };

    return (
        <InfoPage
            {...navBarProps}
            iconName={props.icon}
            iconColor="primary"
            headerText={<DangerouslyHtml dangerouslyHtml={props.title} />}
            secondaryText={<DangerouslyHtml dangerouslyHtml={props.text} />}
            primaryButtonCaption={props.firstButton}
            primaryButtonType="link"
            primaryButtonLink={props.firstButtonLink}
            primaryButtonOnClick={sendEvent}
        />
    );
};

export default CommonIntro;
